import Api from '../../utils/axios';

export const eventsData = async () => {
  try {
    return await Api.get('/events', {});
  } catch (error) {
    return {
      status: 404,
    };
  }
};

export const eventsbyId = async (eventId) => {
  try {
    const events = await Api.get('/events', {});

    const event = events.data?.data?.find((event) => event.id === eventId);

    if (event) {
      return {
        status: 200,
        data: event,
      };
    } else {
      return {
        status: 404,
        message: 'Event not found',
      };
    }
  } catch (error) {
    return {
      status: 404,
    };
  }
};
